import { useSite } from "../context/SiteContext";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "BharatBest Fintech Private Limited respects your privacy. Information you submit through this website — including your name, contact details, financial profile and documents — is used solely to evaluate your enquiry, match you with potentially suitable lending partners and facilitate your application.",
      "We may share relevant details with banking/NBFC lending partners strictly for the purpose of processing your enquiry or application, and only with your consent. We do not sell your personal information to third parties.",
      "Access to your data is restricted to authorized team members under role-based controls. You may request correction or deletion of your information by contacting us through the details on our Contact page.",
      "This policy is a general template. The final legally reviewed wording will be published by BharatBest Fintech Private Limited.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "By using this website, you acknowledge that BharatBest Fintech Private Limited is a financial services intermediary/DSA marketplace and not a bank, NBFC or lending institution.",
      "All loan products displayed are offered by independent banking and NBFC lending partners. Approval, interest rates, tenure, fees and all other terms are determined solely by the respective lender after their own eligibility assessment and verification.",
      "Calculators and eligibility tools on this website provide indicative estimates only and do not constitute an offer, approval or financial advice.",
      "Content on this website is for general information. BharatBest Fintech may update product details, partners and content at any time through its content management system.",
      "These terms are a general template. The final legally reviewed wording will be published by BharatBest Fintech Private Limited.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: null, // uses settings.disclaimer plus standard text
  },
  cookie: {
    title: "Cookie Policy",
    body: [
      "This website uses essential cookies to operate securely (for example, admin session cookies) and may use analytics cookies to understand how visitors use the site, so we can improve it.",
      "Analytics and advertising cookies (such as Google Analytics or Meta Pixel) are activated only when configured by BharatBest Fintech. These cookies may collect anonymized usage information such as pages visited, device type and approximate location.",
      "You can control or delete cookies through your browser settings. Disabling essential cookies may affect website functionality.",
      "This policy is a general template. The final legally reviewed wording will be published by BharatBest Fintech Private Limited.",
    ],
  },
  consent: {
    title: "Consent & Communication Policy",
    body: null, // uses settings.consent_text plus standard text
  },
};

export default function Legal({ type }) {
  const { settings } = useSite();
  const c = CONTENT[type];
  const paragraphs = type === "disclaimer"
    ? [settings.disclaimer, "Nothing on this website constitutes financial advice or a solicitation of a loan. Product availability, rates and offers are subject to change and lender policy. Customers should read the lender's most important terms and conditions carefully before signing any agreement."]
    : type === "consent"
    ? [settings.consent_text, "You may withdraw your consent to be contacted at any time by writing to us through the contact details published on this website. Withdrawing consent does not affect processing already carried out.", "Communication may occur via phone call, SMS, WhatsApp or email regarding your enquiry, application status and closely related services."]
    : c.body;

  return (
    <div data-testid={`legal-${type}-page`} className="container-site py-14 lg:py-20">
      <div className="max-w-3xl mx-auto">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold text-brand-dark">{c.title}</h1>
        <div className="mt-8 card-site p-8 sm:p-10 space-y-5">
          {paragraphs.filter(Boolean).map((p, i) => (
            <p key={i} className="text-sm md:text-base text-brand-dark/75 leading-relaxed">{p}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
